import { render, staticRenderFns } from "./ModalShipmentItem.vue?vue&type=template&id=74503e9b&lang=pug"
import script from "./ModalShipmentItem.vue?vue&type=script&lang=js"
export * from "./ModalShipmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports